import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';
import { SalatiStatusDto } from '../../../dto/salatistatus/salatistatusdto';

export interface SalatiStatusResponse extends APIResponse
{
    getListOfSalatiStatusDtos(): SalatiStatusDto[];
}

export class SalatiStatusResponseDtoImpl extends APIResponseDtoImpl implements SalatiStatusResponse
{
    private salatiStatusResponseDtos : SalatiStatusDto[];

    getListOfSalatiStatusDtos(): SalatiStatusDto[]
    {
        return this.salatiStatusResponseDtos;
    }
    setSalatiStatusDtos(salatiStatusResponseDtos: SalatiStatusDto[])
    {
        this.salatiStatusResponseDtos = salatiStatusResponseDtos;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/salati/salatistatus/salatistatusresponse.tsx